<div class="tabbable__body margin--none shadow-z-1">
  <default-mms-value-setting></default-mms-value-setting>
  <div class="divider medium margin-top-bottom--2x"></div>
  <invalid-mms-days-admin></invalid-mms-days-admin>
</div>